import React from 'react';
import { findSelectorStyle, selectorBoxStyle, selectorSeparator } from './selectorStyle';

/**
 * Bloc Puck — box « Choix » du proposal, en lecture seule.
 *
 * Affiche les seules options retenues, jointes par le séparateur du style du
 * document — comme le fait le proposal. Un choix sans réponse ne produit aucun
 * bloc : le parser l'écarte en amont.
 */
const ProposalSelector = ({
  id,
  options = [],
  selectorStyleId = null,
  selectorStyles = [],
}) => {
  if (!options.length) return null;

  const styleDef = findSelectorStyle(selectorStyles, selectorStyleId);

  return (
    <div
      id={id}
      style={{
        display: 'flex',
        width: '100%',
        minHeight: 16,
        ...selectorBoxStyle(styleDef),
      }}
    >
      <span style={{ wordWrap: 'break-word', whiteSpace: 'break-spaces' }}>
        {options.join(selectorSeparator(styleDef))}
      </span>
    </div>
  );
};

export default ProposalSelector;
